
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

// French routes that don't have a language prefix
const frenchRoutes = [
  "/",
  "/galerie",
  "/equipements",
  "/reserver",
  "/contact",
  "/environs",
  "/acces",
  "/mentions-legales",
  "/mes-reservations",
  "/profil",
];

/**
 * Hook that syncs the language context to French when on French routes
 */
export const useFrenchRouteSync = () => {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Check if we're on a French route (no language prefix)
    const isOnFrenchRoute = frenchRoutes.includes(currentPath) || 
      frenchRoutes.some(route => currentPath === route);
    
    // Check if path starts with a language prefix
    const hasLangPrefix = /^\/(en|es|it|de|nl)(\/|$)/.test(currentPath);
    
    // If on a French route and language is not French, set it to French
    if (isOnFrenchRoute && !hasLangPrefix && language !== 'fr') {
      setLanguage('fr');
    }
  }, [location.pathname, language, setLanguage]);
};
